import { LanguageTranslateValues } from "./../models/language.translate.values";

import BaseService from "./_base.service";

const endpoint = "language/translate/values";

const LanguageTranslateValuesService = {
  ...BaseService<LanguageTranslateValues>({ endpoint }),
};

export default LanguageTranslateValuesService;
